<template>
  <div class="sort">
    <div class="sort__title">{{ $res.Views.LocalHotelSearch_SortBy }}</div>
    <button class="sort__button" :class="{ active: sort.field === 'name' }" @click="onSortClick('name')">
      <span>{{ $res.Views.LocalHotelSearch_Name }}</span>
      <SvgIcon v-if="sort.field === 'name'" :icon="icon" width="12" height="12" view-box="0 0 16 16" />
    </button>
    <button class="sort__button" :class="{ active: sort.field === 'category' }" @click="onSortClick('category')">
      <span>{{ $res.Views.LocalHotelSearch_Category }}</span>
      <SvgIcon v-if="sort.field === 'category'" :icon="icon" width="12" height="12" view-box="0 0 16 16" />
    </button>
    <button class="sort__button" :class="{ active: sort.field === 'location' }" @click="onSortClick('location')">
      <span>{{ $res.Views.LocalHotelSearch_Location }}</span>
      <SvgIcon v-if="sort.field === 'location'" :icon="icon" width="12" height="12" view-box="0 0 16 16" />
    </button>
  </div>
</template>

<script setup>
import { computed } from "vue";
import SvgIcon from "@/common/controls/SvgIconControl.vue";

const props = defineProps({
  value: String,
});

const emit = defineEmits(["update:value"]);

const sort = computed(() => {
  const [field, mode] = (props.value || "name-asc").split("-");
  return { field, mode };
});

const icon = computed(() => sort.value.mode === "asc" ? "chevron/up" : "chevron/down");

function onSortClick(field) {
  if (sort.value.field === field) {
    emit("update:value", `${field}-${sort.value.mode === "asc" ? "desc" : "asc"}`);
    return;
  }

  emit("update:value", `${field}-asc`);
}
</script>

<style scoped lang="scss">
.sort {
  display: flex;
  align-items: center;
  gap: 16px;
}

.sort__title {
  color: var(--second-20);
}

.sort__button {
  display: flex;
  align-items: center;
  gap: 6px;
  appearance: none;
  border: none;
  outline: none;
  background: transparent;
  cursor: pointer;
  padding: 0;
  color: var(--main-10);

  > span {
    flex: 1 1 0;
    min-width: 0;
  }

  > svg {
    flex: 0 0 auto;
    color: var(--main-10);
  }

  &.active {
    color: var(--second-10);
  }
}
</style>
